import { api } from '../index.js'

export default {
  namespaced: true,

  state: {
    campaigns: [],
    campaign: {}
  },

  mutations: {
    updateCampaigns(state, campaigns) {
      state.campaigns = campaigns
    },

    updateCampaign(state, campaign) {
      state.campaign = campaign
    },

    updateAttribute(state, { attribute, value }) {
      state.campaign[attribute] = value
    }
  },

  actions: {
    async fetchAll({ commit, state }, includeStages = false) {
      let [campaigns] = await api.campaigns.all(includeStages)
      commit('updateCampaigns', campaigns)
    },

    async fetchOne({ commit, state }, id) {
      let [campaign] = await api.campaigns.one(id)
      commit('updateCampaign', campaign)
      return campaign
    },

    async saveCampaign({ commit, state }) {
      let [campaign] = await api.campaigns.save(state.campaign)
      commit('updateCampaign', campaign)
      return campaign
    },

    newCampaign({ commit, state }) {
      // TODO: maybe move to mutator?
      const campaign = {
        name: '',
        active: true,
        filter_id: '',
        filter_model: null,
        use_assigned_agent: true,
        only_unique_emails: false,
        filter_snapshot: [],
        category_name: '',
        description: '',
        agent: null
      }

      commit('updateCampaign', campaign)
    },

    async deleteCampaign({ commit, state }, id) {
      await api.campaigns.delete(id)
    },

    updateCampaign({ commit, state }, campaign) {
      commit('updateCampaign', campaign)
    },

    updateAttribute({ commit, state }, { attribute, value }) {
      commit('updateAttribute', { attribute, value })
    }
  }
}
